import { render, staticRenderFns } from "./ReservationColumnShow.vue?vue&type=template&id=23dbdcf6&scoped=true&"
import script from "./ReservationColumnShow.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnShow.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnShow.vue?vue&type=style&index=0&id=23dbdcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dbdcf6",
  null
  
)

export default component.exports